import { useNavigate } from 'react-router-dom';

export default function AdminHeader() {

    const navigate = useNavigate();

    const handleLogout = () => {

        localStorage.removeItem('authToken');
        localStorage.removeItem('authUser');

        sessionStorage.removeItem('authToken');
        sessionStorage.removeItem('authUser');

        navigate('/admin-login');
    };

    return (
        <header className="admin-header">

            <img
                src="/logo.svg"
                alt="Logo"
                className="admin-logo"
            />

            <button
                className="logout-button"
                onClick={handleLogout}
            >
                Logout
            </button>

        </header>
    );
}
